function getArrayFromQueryParam (value) {
  if (value === undefined || value === '') {
    return null
  }
  return value.split(',').map(s => s.trim()).filter(Boolean)
}

function buildMixServices (partners, plans) {
  const mixServices = [...(partners || []), ...(plans || [])]
  return mixServices.length > 0 ? mixServices : undefined
}

function resolvePartnerAddons (_partners, _plans, addons) {
  // Addons can be present even when partners/plans are missing (e.g. URL param only).
  // Cart add should still carry addon codes; backend/cart decides validity.
  if (!addons?.length) {
    return null
  }
  return addons
}

/**
 * Parse Play Mix URL query params for mobilabonnement / internet flows.
 * mixServices = partners + plans (PlayPoList). partnerAddons only when all three are present.
 */
export function getPlayMixQueryParams (query = {}) {
  const partners = getArrayFromQueryParam(query.partners ?? query.tlmmix)
  const plans = getArrayFromQueryParam(query.plans)
  const addons = getArrayFromQueryParam(query.addons)

  return {
    partners,
    plans,
    addons,
    mixServices: buildMixServices(partners, plans),
    partnerAddons: resolvePartnerAddons(partners, plans, addons)
  }
}
